import FieldForm from "../FieldForm";
import styles from "../Overlay/Overlay.module.css"
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { editUser } from "../../api/users.api";
import {
    SelectRoot,
    SelectTrigger,
    SelectContent,
    SelectItem
} from "../ui/select"
import { useState, useMemo } from "react";
import Overlay from "../Overlay";
import ButtonForm from "../ButtonForm";
import LabelRequired from "../LabelRequired";
import FieldFormRequired from "../FieldFormRequired";
import HeaderForm from "../HeaderForm";


function FormUserEdit({ setIsOpen, thisUser }) {
    const [cargo, setCargo] = useState(thisUser.cargo);
    const [setor, setSetor] = useState(thisUser.departamento);
    const [email, setEmail] = useState(thisUser.userName);
    const [nome, setNome] = useState(thisUser.name);

    const regras = useMemo(() => ({
        temNumero: /\d/,
        temEspecial: /[@#!$*&]/,
        temMaiuscula: /[A-Z]/,
        temMinuscula: /[a-z]/
    }), []);




    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            Id: thisUser.id,
            Name: nome,
            UserName: email,
            Departamento: setor,
            EmailConfirmed: thisUser.emailConfirmed,
            Cargo: cargo,
        }

        console.log(payload)

        await editUser(payload)
            .then(() => {
                setIsOpen(false);
                return toast.success("Registro Atualizado!")
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })

    }


    return (
        <Overlay>
            <form onSubmit={handleSubmit}>
                <HeaderForm 
                    title="Editar Usuário"
                    close={() => setIsOpen(false)}
                />
                <FieldFormRequired
                    type="text"
                    placeholder="Digite o nome completo"
                    field="Nome completo"
                    setThing={setNome}
                    value={nome}
                />
                <FieldFormRequired
                    type="email"
                    placeholder="Digite@email.com"
                    field="Email"
                    setThing={setEmail}
                    value={email}
                />
                <div className={styles.containerSelect}>
                    <div className={styles.select}>
                        <LabelRequired>Cargo do sistema</LabelRequired>
                        <SelectRoot value={cargo} onValueChange={setCargo}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value="Líder">Líder</SelectItem>
                                <SelectItem value="Supervisor">Supervisor</SelectItem>
                                <SelectItem value="Admin">Admin</SelectItem>
                            </SelectContent>
                        </SelectRoot>
                    </div>
                    <div className={styles.select}>
                        <LabelRequired>Setor</LabelRequired>               
                         <SelectRoot value={setor} onValueChange={setSetor}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value="Infraestrutura">Infraestrutura</SelectItem>
                                <SelectItem value="Residencial">Residencial</SelectItem>
                                <SelectItem value="Engenharia">Engenharia</SelectItem>
                                <SelectItem value="Diretoria">Diretoria</SelectItem>
                                <SelectItem value="Financeiro">Financeiro</SelectItem>
                                <SelectItem value="Outro">Outro</SelectItem>
                            </SelectContent>
                        </SelectRoot>
                    </div>
                </div>
                <ButtonForm>Editar</ButtonForm>
            </form >
        </Overlay >
    )
}


export default FormUserEdit;